<template>
    <div class="modal fade" id="usuario_delete_modal" data-backdrop="static">
        <div class="modal demo-modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <b>Deletar</b>
                        </h5>
                    </div>
                    <div class="modal-body"> 

                        <dot :isVisible="isLoading"></dot>

                        <div v-if="!isLoading">
                            Deseja realmente DELETAR o(a) <b>{{ delete_usuario.name }}</b>?
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-danger"
                            @click.prevent.stop="deleteUsuario">
                            Deletar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

	import { eventBus } from '../../app';
    import Dot from '../loadder/Dot.vue';

    export default {

    	components: {
            Dot
        },


    	data(){
            return {
                currentPagePagination: null,

            	isLoading: false,

                //ARRAYS
            	errors: [],

                //OBJECTS
                delete_usuario: {}
            }
        },

        mounted(){
        	this.registryEventOpenModalDeleteUsuario();
        },

        methods: {
            registryEventOpenModalDeleteUsuario(){
                eventBus.$on('eventOpenModalDeleteUsuario', (deleteUsuario, currentPage) => {
                	this.errors = [];
                    this.delete_usuario = Object.assign({}, deleteUsuario);
                    this.currentPagePagination = currentPage;
                    $("#usuario_delete_modal").modal("show");
                });
            },

            emitEventGetUsuarios(){
                eventBus.$emit('eventGetUsuarios', this.currentPagePagination);
            },

            deleteUsuario()
            {
                this.isLoading = true;
                axios.delete(
                    '/usuario/' + this.delete_usuario.id
                )
                .then(response => {
                    this.isLoading = false;
                    $("#usuario_delete_modal").modal("hide");
                    toastr.success(response.data.message);
                    this.emitEventGetUsuarios();
                })
                .catch(error => {
                    this.isLoading = false;
                    let erroObject = error.response.data;
                    if(erroObject.message)
                    {
                        toastr.error(erroObject.message);
                    }
                });
            }

            
            
        }
    }
</script>